import { useState, useEffect } from "react";
import ModalFrame from "../../components/modal/ModalFrame";
import { Dialog } from "@headlessui/react";
import { BanIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";

import * as api from "./apiService";
import { toast } from "react-toastify";

const JobNotInvoiceModal = ({ isOpen, handleClose, invoiceDetails }) => {
  const navigate = useNavigate();

  const handleNotInvoice = async () => {
    const request = {
      status: "N",
    };

    try {
      await api.invoiceJob(invoiceDetails.job_id, request);

      toast.success("Job not invoiced!");

      navigate(0);
    } catch (err) {
      toast.error("Unable to not invoice job");
    }
  };

  return (
    <ModalFrame isModalOpen={isOpen}>
      <div className="job-details-redesign text-sm leading-6 text-slate-700">
        <div className="">
          <div className="flex items-center gap-3 border-b border-slate-200 pb-5">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-50 text-[#E3222A]">
              <BanIcon className="h-5 w-5" aria-hidden="true" />
            </span>
            <Dialog.Title
              as="h3"
              className="text-lg font-semibold leading-6 tracking-tight text-slate-950"
            >
              Not Invoice Job
            </Dialog.Title>
          </div>

          <div className="mt-2">
            <p className="py-4 text-sm leading-6 text-slate-600">
              Are you sure you want to flag this job as not invoiced?
            </p>
          </div>
        </div>

        <div className="mt-6 border-t border-slate-200 pt-5 sm:flex sm:flex-row-reverse sm:gap-3">
          <button
            type="button"
            onClick={handleNotInvoice}
            className="inline-flex min-h-[40px] w-full items-center justify-center rounded-lg border border-transparent
                              bg-[#E3222A] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#c91d24]
                              focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:w-auto"
          >
            Not Invoice
          </button>

          <button
            type="button"
            onClick={handleClose}
            className="mt-3 inline-flex min-h-[40px] w-full items-center justify-center rounded-lg border
                              border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition
                              hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 sm:mt-0 sm:w-auto"
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalFrame>
  );
};

export default JobNotInvoiceModal;
